export default function normalizeItem(item) {
  return {
    id: item.id,
    label: item.label,
    color: item.color.replace('#', '') ?? '000000',
    image: item.image,
    defaultSpeed: item.defaultSpeed ?? 0,
  }
}

export function mutateNormalize(item) {
  return {
    ...item,
    defaultSpeed: parseInt(item.defaultSpeed ?? 0),
  }
}
